import {
  login,
  logout,
  getUserInfo
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  getUserInfoCookie,
  setUserInfoCookie,
  removeUserInfoCookie
} from '@/utils/auth'
import {
  resetRouter
} from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getUserInfoCookie() || {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  // user login
  login({
    commit
  }, fromData) {
    return new Promise((resolve, reject) => {
      login(fromData).then(res => {
        const {
          data,
          code
        } = res
        if (code == 200) {
          commit('SET_TOKEN', data)
          setToken(data)
          resolve()
        }
      }).catch(err => {
        console.log(err);
        reject(err)
      })
    })
  },

  // get user info
  getUserInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        const {
          data,
          code
        } = res
        if (code == 200) {
          commit('SET_USER_INFO', data)
          setUserInfoCookie(data)
          resolve(data)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },

  // user logout
  logout({
    commit
  }) {
    return new Promise((resolve, reject) => {
      logout().then((res) => {
        const {
          code
        } = res
        if (code == 200) {
          removeToken() // must remove  token  first
          removeUserInfoCookie() //删除用户信息
          commit('RESET_STATE')
          resetRouter()
          resolve()
        }
      }).catch(err => {
        reject(err)
      })
    })
  },

  // remove token and userInfo
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      removeUserInfoCookie() //删除用户信息
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}